import styled from 'styled-components';
var FooterStyle = styled.footer.withConfig({
  displayName: "Footerstyles__FooterStyle",
  componentId: "pantheon__sc-1rrhlty-0"
})(["background-color:#f7f7f7;min-height:5rem;width:100%;@media (max-width:576px){min-height:11.875rem;}"]);
export { FooterStyle };